/* eslint-disable max-lines */
import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useStateMachine } from "little-state-machine";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { convertQuickRequest } from "api";
import errorToast from "helpers/errorToast";
import testIds from "constants/testIds";

function ConvertQR() {
  const { state }: any = useStateMachine();
  const intl = useIntl();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // Converts the quick request to a quote and then navigates to the form with prefill data
  const handleConvertClick = () => {
    setIsLoading(true);
    convertQuickRequest(state.shipmentId)
      .then((res) => {
        const draftReference = res.data.reference_number;
        navigate(`/quote-request?draft_id=${draftReference}`);
      })
      .catch((err) => {
        errorToast(err);
        setIsLoading(false);
      });
  };

  return (
    <OverlayTrigger
      placement="bottom"
      delay={{ show: 250, hide: 0 }}
      overlay={
        <Tooltip id="">
          <FormattedMessage id="components.molecules.navigation.convertLabel" defaultMessage="Convert to quote request" />
        </Tooltip>
      }
    >
      <button
        type="button"
        className="cta-button outline"
        onClick={handleConvertClick}
        disabled={isLoading}
        data-testid={testIds.SHIPMENT_DASHBOARD_CONVERT_BUTTON}
      >
        {intl.formatMessage({
          id: "components.molecules.navigation.convert",
          defaultMessage: "Convert",
        })}
      </button>
    </OverlayTrigger>
  );
}

export default ConvertQR;
